import clsx from "clsx";
import { Fragment, useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Tab } from "@headlessui/react";
import Meta from "modules/Meta";
import Footer from "container/home/Footer";
import ProxyNav from "components/organism/Navbar/ProxyNav";
import ResidentialProxy from "pages/products/ResidentialProxy";
import DedicatedProxy from "pages/products/DedicatedProxy";
import SOCKSv5Proxy from "pages/products/SOCKSv5Proxy";
import SharedProxy from "pages/products/SharedProxy";
import HTTPProxy from "pages/products/HTTPProxy";
import AmazonProxy from "pages/products/AmazonProxy";
import LinkedInProxy from "pages/products/LinkedInProxy";
import { connect, useDispatch } from "react-redux";
import { updateIdMenu } from "state/proxy.action";

const ProxyLayouts = (props) => {
    const { updateMenu, idMenuFromStore } = props;
    const currentLocation = useLocation().pathname;
    const [idMenu, setIdMenu] = useState(idMenuFromStore);


    const proxyRefs = useRef(null);

    const dispatch = useDispatch();

    const eventHandlers = (numbers) => {
        setIdMenu(numbers);
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });

        console.log("Menu ID : ", idMenuFromStore);
    }, [currentLocation, setIdMenu, idMenuFromStore]);

    const residentialRef = useRef();
    const httpRef = useRef();
    const socksRef = useRef();
    const dedicatedRef = useRef();
    const sharedRef = useRef();
    const amazonRef = useRef();
    const linkedinRef = useRef();

    const residentialTabHandler = () => {
        setIdMenu(1);
        dispatch(updateMenu(1));
        window.localStorage.setItem("proxyUniqueId", 1);
        residentialRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    };

    const httpTabHandler = () => {
        setIdMenu(2);
        dispatch(updateMenu(2));
        window.localStorage.setItem("proxyUniqueId", 2);
        httpRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    };

    const socksTabHandler = () => {
        setIdMenu(4);
        dispatch(updateMenu(4));
        window.localStorage.setItem("proxyUniqueId", 4);
        socksRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    };

    const dedicatedTabHandler = () => {
        setIdMenu(5);
        dispatch(updateMenu(5));
        window.localStorage.setItem("proxyUniqueId", 5);
        dedicatedRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    };

    const sharedTabHandler = () => {
        setIdMenu(3);
        dispatch(updateMenu(3));
        window.localStorage.setItem("proxyUniqueId", 3);
        sharedRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    };

    const amazonTabHandler = () => {
        setIdMenu(6);
        dispatch(updateMenu(6));
        window.localStorage.setItem("proxyUniqueId", 6);
        amazonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    };

    const linkedinTabHandler = () => {
        setIdMenu(7);
        dispatch(updateMenu(7));
        window.localStorage.setItem("proxyUniqueId", 7);
        linkedinRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
    };

    useEffect(() => {
        if (idMenuFromStore === 2) { httpTabHandler(); }
        if (idMenuFromStore === 1) { residentialTabHandler(); }
        if (idMenuFromStore === 4) { socksTabHandler(); }
        if (idMenuFromStore === 3) { sharedTabHandler(); }
        if (idMenuFromStore === 5) { dedicatedTabHandler(); }
        if (idMenuFromStore === 6) { amazonTabHandler(); }
        if (idMenuFromStore === 7) { linkedinTabHandler(); }
    }, [idMenu, setIdMenu, idMenuFromStore]);

    const [title] = useState([
        { id: 1, title: "Residential Proxy", route: "residential" },
        { id: 2, title: "HTTP Proxy", route: "http" },
        { id: 3, title: "SOCKSV5 Proxy", route: "socksv5" },
        { id: 4, title: "Dedicated Proxy", route: "dedicated" },
        { id: 5, title: "Shared Proxy", route: "shared" },
        { id: 6, title: "Amazon Proxy", route: "amazon" },
        { id: 7, title: "LinkedIn Proxy", route: "linkedin" },
    ]);
    return (
        <Fragment>
            <Meta title="Proxy" />
            <ProxyNav navigationRef={proxyRefs} />
            <div className={clsx(
                "w-full mt-8 phone:mt-6 mb-0",
                "max-w-[1440px] mx-auto",
                "px-6 tablet:px-8 desktop:px-[120px]",
                "overflow-auto scrollbar-hide"
            )}>
                <div className="phone:w-[875px] phone:pr-6">
                    <Tab.Group>
                        <Tab.List className="w-full flex space-x-1 phone:space-x-3 justify-between phone:justify-start tablet:space-x-0 rounded-lg bg-neutral-10 border border-neutral-30 p-1">
                            <button ref={residentialRef} onClick={residentialTabHandler} id="residential" className={clsx(
                                "w-fit rounded-lg text-center py-[11.5px] tablet:py-[7.5px] phone:py-[8.5px] px-3 tablet:px-3 phone:text-xs tablet:text-xs text-sm leading-[17px] tracking-text",
                                "focus:outline-none",
                                idMenu === 1
                                    ? "bg-primary-surface text-primary-main font-semibold"
                                    : "text-neutral-50 font-normal"
                            )}
                            >Residential Proxy</button>
                            <button ref={httpRef} onClick={httpTabHandler} id="http" className={clsx(
                                "w-fit rounded-lg text-center py-[11.5px] tablet:py-[7.5px] phone:py-[8.5px] px-3 tablet:px-3 phone:text-xs tablet:text-xs text-sm leading-[17px] tracking-text",
                                "focus:outline-none",
                                idMenu === 2
                                    ? "bg-primary-surface text-primary-main font-semibold"
                                    : "text-neutral-50 font-normal"
                            )}
                            >HTTP Proxy</button>
                            <button ref={socksRef} onClick={socksTabHandler} id="socksv5" className={clsx(
                                "w-fit rounded-lg text-center py-[11.5px] tablet:py-[7.5px] phone:py-[8.5px] px-3 tablet:px-3 phone:text-xs tablet:text-xs text-sm leading-[17px] tracking-text",
                                "focus:outline-none",
                                idMenu === 4
                                    ? "bg-primary-surface text-primary-main font-semibold"
                                    : "text-neutral-50 font-normal"
                            )}
                            >SOCKSV5 Proxy</button>
                            <button ref={dedicatedRef} onClick={dedicatedTabHandler} id="dedicated" className={clsx(
                                "w-fit rounded-lg text-center py-[11.5px] tablet:py-[7.5px] phone:py-[8.5px] px-3 tablet:px-3 phone:text-xs tablet:text-xs text-sm leading-[17px] tracking-text",
                                "focus:outline-none",
                                idMenu === 5
                                    ? "bg-primary-surface text-primary-main font-semibold"
                                    : "text-neutral-50 font-normal"
                            )}
                            >Dedicated Proxy</button>
                            <button ref={sharedRef} onClick={sharedTabHandler} id="shared" className={clsx(
                                "w-fit rounded-lg text-center py-[11.5px] tablet:py-[7.5px] phone:py-[8.5px] px-3 tablet:px-3 phone:text-xs tablet:text-xs text-sm leading-[17px] tracking-text",
                                "focus:outline-none",
                                idMenu === 3
                                    ? "bg-primary-surface text-primary-main font-semibold"
                                    : "text-neutral-50 font-normal"
                            )}
                            >Shared Proxy</button>
                            <button ref={amazonRef} onClick={amazonTabHandler} id="amazon" className={clsx(
                                "w-fit rounded-lg text-center py-[11.5px] tablet:py-[7.5px] phone:py-[8.5px] px-3 tablet:px-3 phone:text-xs tablet:text-xs text-sm leading-[17px] tracking-text",
                                "focus:outline-none",
                                idMenu === 6
                                    ? "bg-primary-surface text-primary-main font-semibold"
                                    : "text-neutral-50 font-normal"
                            )}
                            >Amazon Proxy</button>
                            <button ref={linkedinRef} onClick={linkedinTabHandler} id="linkedin" className={clsx(
                                "w-fit rounded-lg text-center py-[11.5px] tablet:py-[7.5px] phone:py-[8.5px] px-3 tablet:px-3 phone:text-xs tablet:text-xs text-sm leading-[17px] tracking-text",
                                "focus:outline-none",
                                idMenu === 7
                                    ? "bg-primary-surface text-primary-main font-semibold"
                                    : "text-neutral-50 font-normal"
                            )}
                            >LinkedIn Proxy</button>
                        </Tab.List>
                    </Tab.Group>
                </div>
            </div>
            {idMenu === 1 ? <ResidentialProxy /> :
                idMenu === 5 ? <DedicatedProxy /> :
                    idMenu === 3 ? <SharedProxy /> :
                        idMenu === 2 ? <HTTPProxy /> :
                            idMenu === 4 ? <SOCKSv5Proxy /> :
                                idMenu === 6 ? <AmazonProxy /> :
                                    idMenu === 7 ? <LinkedInProxy /> : ""}
            <Footer heroRefs={proxyRefs} eventHandlers={eventHandlers} />
        </Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        idMenuFromStore: state.proxy.idMenu
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateMenu: (id) => dispatch(updateIdMenu(id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProxyLayouts);